<template lang="pug">
  div(id="app")
    navbar
    router-view
</template>

<script>
import Navbar from './components/Nav'

export default {
  components: {
    Navbar
  },
  name: 'App'
}
</script>

<style>
  body {
    background: #f9f9fa !important;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .btn-primary {
    color: #fff !important;
    font-weight: bold !important;
    background-color: #7953f5 !important;
    border-color: #663bf4 !important;
    box-shadow: 0 1px 2px 0 rgba(0,0,0,.2) !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue